import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import * as Models from '../../../models/index';
import { ConstantsService } from '../../Constants/constants.service';

@Injectable({
  providedIn: 'root',
})
export class UserDataService {
    private service_URL: any;
  constructor(private httpClient: HttpClient) {
    this.service_URL = ConstantsService
  }

  getUserData(email: any): Observable<Models.DM.IUserProfile> {
    return this.httpClient.get(this.service_URL.Users.getuserbyemail + email) as Observable<any>;
  }

  getCurrentBadgeRequestStatuses(): Observable<any> {
    return of({});
    // return this.httpClient.get(ApiConfig.Account.getCurrentStatus) as Observable<any>;
  }
}
